import { render, staticRenderFns } from "./footPage.vue?vue&type=template&id=4e0ee251"
import script from "./footPage.vue?vue&type=script&lang=js"
export * from "./footPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports